export default __webpack_public_path__ + "static/media/TokenAllocation.9fcaa0ea.txt";